import { createPresenceClient } from "../shared/presence-client.js";
import { mountStrip } from "../shared/strip.js";
import { mountFeed } from "./feed.js";
import { mountProse } from "../prose.js";

window.addEventListener("load", () => {
  const presence = createPresenceClient();
  mountStrip(presence);
  presence.connect();

  const head = document.querySelector(".cd-head-section");
  if (head) mountProse(head, {});

  mountFeed(document.getElementById("feed-root"));
});
